import axios from "axios";
import { IAxiosResponse } from "../interfaces/IAxiosResponse";
import { IPagination } from "../interfaces/IPagination";
import {
  IEntityChangeGroup,
  IEntityChangeLogDetail,
  IEntityChangeLogHistoryParams,
  IEntityChangeLogListItem,
  IEntityChangeLogRevertResult,
  IEntityChangeActionRevertResult
} from "../interfaces/endpoints/IEntityChangeLog.types";
import { serialize } from "../utils/serializeToQueryString";

const BASE_URL = "v1/EntityChangeLog";

// History of one entity, newest first. SuperAdmin only on the backend.
export const getEntityChangeHistory = async (
  params: IEntityChangeLogHistoryParams
): Promise<IAxiosResponse<IPagination<IEntityChangeLogListItem>>> =>
  axios.get(`${BASE_URL}${serialize(params)}`);

// The same history, one item per action: every row a request wrote, grouped. Paged by action.
export const getEntityChangeGroups = async (
  params: IEntityChangeLogHistoryParams
): Promise<IAxiosResponse<IPagination<IEntityChangeGroup>>> =>
  axios.get(`${BASE_URL}/grouped${serialize(params)}`);

// One row with its previous state and whether it can be reverted.
export const getEntityChangeLog = async (
  id: number
): Promise<IAxiosResponse<IEntityChangeLogDetail>> => axios.get(`${BASE_URL}/${id}`);

// Writes the row's previous state back, or soft-deletes the entity when the row is its creation.
// Overwrites every later change to the same entity; the response says how many.
export const revertEntityChange = async (
  id: number
): Promise<IAxiosResponse<IEntityChangeLogRevertResult>> =>
  axios.post(`${BASE_URL}/${id}/revert`);

// Undoes a whole action: every entity the request with this correlation id changed goes back to what
// it was before, in one transaction. Rows that cannot be undone are reported in `skipped`.
export const revertEntityAction = async (
  correlationId: string
): Promise<IAxiosResponse<IEntityChangeActionRevertResult>> =>
  axios.post(`${BASE_URL}/grouped/revert`, { correlationId });
